module.exports = __webpack_public_path__ + "static/media/security.96d744e1.webp";